import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Home from "./components/Home";
import AccountHeadsList from "./components/AccountHeadsList";
import InvestList from "./components/invest/InvestList";

import AgentReceivePayments from "./components/reports/AgentReceivePayments";
import DailyExpenseReport from "./components/reports/DailyExpenseReport";
import DailyReceivedReport from "./components/reports/DailyReceivedReport";
import InvoiceDuesReport from "./components/reports/InvoiceDuesReport";
import MonthlyProfitLoss from "./components/reports/MonthlyProfitLoss";
import InvestReport from "./components/reports/InvestReport";
import AgentList from "./components/agent/AgentList";
import ProjectList from "./components/project/ProjectList";
import ProjectMedicalList from "./components/project_medical/ProjectMedicalList";
import ProjectVisaList from "./components/project_visa/ProjectVisaList";
import ProjectBiometricList from "./components/project_biometric/ProjectBiometricList";
import ProjectBMETList from "./components/project_BMET/ProjectBMETList";
import ProjectFlightList from "./components/project_flight/ProjectFlightList";
import ProjectServiceChargeList from "./components/project_service_charge/ProjectServiceChargeList";
import TradeList from "./components/trade/TradeList";
import VisaNoList from "./components/visa-number/VisaNoList";
import EmployerList from "./components/employer/EmployerList";
import ExpenseList from "./components/expense/ExpenseList";
import ProjectReport from "./components/reports/ProjectReport";
import { hasPerm } from "./mdsir/MdsirUtils";

Vue.use(Router);

const hasPermission = (to, from, next) => {
  let logged = store.getters["common/logged"];
  let loggedRole = logged.user ? logged.user.role : "guest";
  // const allowedRoles = permissions[to.name];
  if (!hasPerm(to.name, [loggedRole])) {
    next("/");
    return;
  }
  next();
};

// Entry Dept. Reports
import EntryAgentReport from "./components/reports/entry/EntryAgentReport";
import EntryCompanyWiseCandidateReport from "./components/reports/entry/EntryCompanyWiseCandidateReport";
import EntryTotalCandidateReport from "./components/reports/entry/EntryTotalCandidateReport";
import EntryCandidateMedicalReport from "./components/reports/entry/EntryCandidateMedicalReport";

// Processing Dept. Reports
import ProcessingCompanyReport from "./components/reports/processing/ProcessingCompanyReport";
import ProcessingMOFAReport from "./components/reports/processing/ProcessingMOFAReport";
import ProcessingTotalEmbassySubmitReport from "./components/reports/processing/ProcessingTotalEmbassySubmitReport";

// Manpower Dept. Reports
import ManpowerTrainingAndFingerReport from "./components/reports/manpower/ManpowerTrainingAndFingerReport";
import ManpowerCompleteStatusReport from "./components/reports/manpower/ManpowerCompleteStatusReport";
import ManpowerFlightCompleteReport from "./components/reports/manpower/ManpowerFlightCompleteReport";

const entryReportRoutes = [      
  {
    path: "/entry_agent_report",
    name: "entry_agent_report",
    component: EntryAgentReport,
    beforeEnter: hasPermission,
    meta: { title: "Entry agent report" },
  },
  {
    path: "/entry_company_wise_candidate_report",
    name: "entry_company_wise_candidate_report",
    component: EntryCompanyWiseCandidateReport,
    beforeEnter: hasPermission,
    meta: { title: "Company wise candidate report" },
  },
  {
    path: "/entry_total_candidate_report",
    name: "entry_total_candidate_report",
    component: EntryTotalCandidateReport,
    beforeEnter: hasPermission,
    meta: { title: "Total Candidate report" },
  },
  {
    path: "/entry_candidate_medical_report",
    name: "entry_candidate_medical_report",
    component: EntryCandidateMedicalReport,
    beforeEnter: hasPermission,
    meta: { title: "Candidate medical report" },
  },
];

const processingReportRoutes = [
  {
    path: "/processing_company_report",
    name: "processing_company_report",
    component: ProcessingCompanyReport,
    beforeEnter: hasPermission,
    meta: { title: "Company report" },
  },
  {
    path: "/processing_mofa_report",
    name: "processing_mofa_report",
    component: ProcessingMOFAReport,
    beforeEnter: hasPermission,
    meta: { title: "MOFA report" },
  },
  {
    path: "/processing_total_embassy_submit_report",
    name: "processing_total_embassy_submit_report",
    component: ProcessingTotalEmbassySubmitReport,
    beforeEnter: hasPermission,
    meta: { title: "Total Candidate report" },
  },
];

const manpowerReportRoutes = [
  {
    path: "/manpower_training_n_finger_report",
    name: "manpower_training_n_finger_report",
    component: ManpowerTrainingAndFingerReport,
    beforeEnter: hasPermission,
    meta: { title: "Training & Finger report" },
  },
  {
    path: "/manpower_complete_status_report",
    name: "manpower_complete_status_report",
    component: ManpowerCompleteStatusReport,
    beforeEnter: hasPermission,
    meta: { title: "Manpower report" },
  },
  {
    path: "/manpower_flight_complete_report",
    name: "manpower_flight_complete_report",
    component: ManpowerFlightCompleteReport,
    beforeEnter: hasPermission,
    meta: { title: "Flight report" },
  },
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/expenses",
      name: "expenses",
      component: ExpenseList,
      beforeEnter: hasPermission,
      meta: { title: "Expense List" },
    },
    {
      path: "/agents",
      name: "agents",
      component: AgentList,
      beforeEnter: hasPermission,
      meta: { title: "Agent List" },
    },
    {
      path: "/employers",
      name: "employers",
      component: EmployerList,
      beforeEnter: hasPermission,
      meta: { title: "Employer List" },
    },
    {
      path: "/projects",
      name: "projects",
      component: ProjectList,
      beforeEnter: hasPermission,
      meta: { title: "Project List" },
    },
    {
      path: "/project-medicals",
      name: "project_medicals",
      component: ProjectMedicalList,
      beforeEnter: hasPermission,
      meta: { title: "Passenger Medical List" },
    },
    {
      path: "/project-visas",
      name: "project_visas",
      component: ProjectVisaList,
      beforeEnter: hasPermission,
      meta: { title: "Passenger Visa List" },
    },
    {
      path: "/project-biometrics",
      name: "project_biometrics",
      component: ProjectBiometricList,
      beforeEnter: hasPermission,
      meta: { title: "Passenger Biometric List" },
    },
    {
      path: "/project-bmet-statuses",
      name: "project_bmet_statuses",
      component: ProjectBMETList,
      beforeEnter: hasPermission,
      meta: { title: "Passenger BMET List" },
    },
    {
      path: "/project-flights",
      name: "project_flights",
      component: ProjectFlightList,
      beforeEnter: hasPermission,
      meta: { title: "Passenger Flight List" },
    },
    {
      path: "/project-service-charges",
      name: "project_service_charges",
      component: ProjectServiceChargeList,
      beforeEnter: hasPermission,
      meta: { title: "Passenger Service Charge List" },
    },
    {
      path: "/trades",
      name: "trades",
      component: TradeList,
      beforeEnter: hasPermission,
      meta: { title: "Trade List" },
    },
    {
      path: "/visa-numbers",
      name: "visa_numbers",
      component: VisaNoList,
      beforeEnter: hasPermission,
      meta: { title: "Visa Number List" },
    },
    {
      path: "/projects_report",
      name: "projects_report",
      component: ProjectReport,
      beforeEnter: hasPermission,
      meta: { title: "Project Report" },
    },    
    {
      path: "/account_heads",
      name: "account_heads",
      component: AccountHeadsList,
      beforeEnter: hasPermission,
      meta: { title: "Account Heads List" },
    },    
    {
      path: "/investments",
      name: "investments",
      component: InvestList,
      beforeEnter: hasPermission,
      meta: { title: "Investment List" },
    },    
    {
      path: "/agent_receive_payments_history",
      name: "agent_receive_payments_history",
      component: AgentReceivePayments,
      beforeEnter: hasPermission,
      meta: { title: "Agent Receive Payments" },
    },
    {
      path: "/daily_expense_report",
      name: "daily_expense_report",
      component: DailyExpenseReport,
      beforeEnter: hasPermission,
      meta: { title: "Daily expense report" },
    },
    {
      path: "/daily_received_report",
      name: "daily_received_report",
      component: DailyReceivedReport,
      beforeEnter: hasPermission,
      meta: { title: "Daily received report" },
    },
    {
      path: "/invoice_dues_report",
      name: "invoice_dues_report",
      component: InvoiceDuesReport,
      beforeEnter: hasPermission,
      meta: { title: "Invoice Dues report" },
    },
    {
      path: "/monthly_profit_loss",
      name: "monthly_profit_loss",
      component: MonthlyProfitLoss,
      beforeEnter: hasPermission,
      meta: { title: "Monthly Profit & Loss" },
    },
    {
      path: "/invest_report",
      name: "invest_report",
      component: InvestReport,
      beforeEnter: hasPermission,
      meta: { title: "Invest report" },
    },
    ...entryReportRoutes,
    ...processingReportRoutes,
    ...manpowerReportRoutes,
  ],
});

//To ingnore the error "NavigationDuplicated: Avoided redundant"
function patchRouterMethod(router, methodName) {
  router["old" + methodName] = router[methodName];
  router[methodName] = async function(location) {
    return router["old" + methodName](location).catch((error) => {
      if (error.name === "NavigationDuplicated") {
        return this.currentRoute;
      }
      throw error;
    });
  };
}

patchRouterMethod(router, "push");
patchRouterMethod(router, "replace");

export default router;
